import { zodResolver } from '@hookform/resolvers/zod';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { EditablePhraseType } from '@/entities/conversations';
import { createRecordSchema } from './recordForm';
import type { TranscriptRecordFormValues } from './types';

/**
 * Форма записи расшифровки её вида. Значения берутся один раз, при открытии: перезапрос расшифровки
 * правку не перетирает.
 */
export const useTranscriptRecordForm = (type: EditablePhraseType, defaultValues: TranscriptRecordFormValues) => {
  const { t } = useTranslation(['dialogs', 'common']);
  const schema = useMemo(() => createRecordSchema(t, type), [t, type]);
  return useForm<TranscriptRecordFormValues>({ defaultValues, resolver: zodResolver(schema) });
};
